/* istanbul ignore file */
import { useBudgetService } from 'domain/shared/budget';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';

const BudgetContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getPermissions } = useBudgetService();
  const CONTEXT_NAME = 'BUDGET_CONTEXT';

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default BudgetContext;
